export default {
  //弹出框
  SHOWPOPUP(state, popupName) {
    this.state[popupName] = true
  },
  HIDEPOPUP(state, popupName) {
    this.state[popupName] = false
  },

  //user
  USERINFO(state, userInfo) {
    this.state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },

  GETPATH(state, path) {
    this.state.signPath = path
  },

  SHOWCTALOGUE(state, isShow) {
    this.state.ctalogueShow = isShow
  },

  GET_MATCHINFO(state, info) {
    this.state.matchInfo = info
  },
  GET_CTALOGUEINFO(state, info) {
    this.state.ctalogueInfo = info
  },

  // WORKDATAS(state,datas){
  //   let workDatas = this.state.workDatas
  //   this.state.workDatas = {...workDatas,...datas}
  // }

  //比赛标题
  MATCHTITLE(state, title) {
    this.state.matchTitle = title
  },

  //配置
  GET_CONFIGS(state,configs){
    let newConfigs = {}
    configs.forEach(config=>{
      newConfigs[config.key] = config.value
    })

    this.state.configs = newConfigs
    localStorage.setItem('configs', JSON.stringify(newConfigs))
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js